import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-bank-movement-grid-page',
  templateUrl: './bank-movement-grid-page.component.html',
  styleUrls: ['./bank-movement-grid-page.component.scss'],
})
export class BankMovementGridPageComponent {}
